import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import Layout from '../../../layouts/dashboard';

const AttendancePage = lazy(() => import('./views/attendance'));

function Modules() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<AttendancePage />} />
            </Routes>
        </Layout>
    );
}

export default Modules;
